import styled from 'styled-components'

export const Label = styled.span`
  font-size: 0.7rem;
  text-transform: uppercase;
  font-weight: 700;
`